// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Validation$OrcaPaymentPage from "../validation/Validation.bs.js";
import * as PaymentEventTypes$OrcaPaymentPage from "./PaymentEventTypes.bs.js";

function shouldEmitEvent(eventType, subscribedEvents) {
  if (subscribedEvents.length === 0) {
    return false;
  } else {
    return subscribedEvents.some(function (subscribed) {
                return subscribed === eventType;
              });
  }
}

function buildCardInfo(cardNumber, expiry, cvc, brand) {
  var cleanNumber = Validation$OrcaPaymentPage.clearSpaces(cardNumber);
  var len = cleanNumber.length;
  var bin = len >= 6 ? cleanNumber.substring(0, 6) : undefined;
  var isCardNumberComplete = Validation$OrcaPaymentPage.isCardNumberEqualsMax(cleanNumber, brand);
  var last4 = isCardNumberComplete ? cleanNumber.substring(len - 4 | 0, len) : undefined;
  var match = Validation$OrcaPaymentPage.getExpiryDates(expiry);
  var year = match[1];
  var month = match[0];
  var expiryMonth = month !== "" ? month : undefined;
  var expiryYear = year.length === 4 ? year : undefined;
  var formattedExpiry = month !== "" && year.length === 4 ? expiry : undefined;
  var isCardNumberValid = Validation$OrcaPaymentPage.cardValid(cardNumber, brand);
  var isExpiryValid = Validation$OrcaPaymentPage.checkCardExpiry(expiry);
  var isCardNumberComplete$1 = isCardNumberComplete && isCardNumberValid;
  var isCvcComplete = Validation$OrcaPaymentPage.checkCardCVC(cvc, brand);
  return {
          bin: bin,
          last4: last4,
          brand: brand === "" ? undefined : brand,
          expiryMonth: expiryMonth,
          expiryYear: expiryYear,
          formattedExpiry: formattedExpiry,
          isCardNumberComplete: isCardNumberComplete$1,
          isCvcComplete: isCvcComplete,
          isExpiryComplete: isExpiryValid,
          isCardNumberValid: isCardNumberValid,
          isExpiryValid: isExpiryValid
        };
}

function buildCardInfoFromSavedCard(bin, last4, brand, expiryMonth, expiryYear, isCvcComplete) {
  var shortYear = expiryYear.length >= 4 ? expiryYear.substring(2, 4) : expiryYear;
  var formattedExpiry = expiryMonth + "/" + shortYear;
  return {
          bin: bin,
          last4: last4,
          brand: brand,
          expiryMonth: expiryMonth,
          expiryYear: expiryYear,
          formattedExpiry: formattedExpiry,
          isCardNumberComplete: true,
          isCvcComplete: isCvcComplete,
          isExpiryComplete: true,
          isCardNumberValid: true,
          isExpiryValid: true
        };
}

function cardInfoToJson(info) {
  return Object.fromEntries([
              [
                "bin",
                Core__Option.getOr(Core__Option.map(info.bin, (function (prim) {
                            return prim;
                          })), null)
              ],
              [
                "last4",
                Core__Option.getOr(Core__Option.map(info.last4, (function (prim) {
                            return prim;
                          })), null)
              ],
              [
                "brand",
                Core__Option.getOr(Core__Option.map(info.brand, (function (prim) {
                            return prim;
                          })), null)
              ],
              [
                "expiryMonth",
                Core__Option.getOr(Core__Option.map(info.expiryMonth, (function (prim) {
                            return prim;
                          })), null)
              ],
              [
                "expiryYear",
                Core__Option.getOr(Core__Option.map(info.expiryYear, (function (prim) {
                            return prim;
                          })), null)
              ],
              [
                "formattedExpiry",
                Core__Option.getOr(Core__Option.map(info.formattedExpiry, (function (prim) {
                            return prim;
                          })), null)
              ],
              [
                "isCardNumberComplete",
                info.isCardNumberComplete
              ],
              [
                "isCvcComplete",
                info.isCvcComplete
              ],
              [
                "isExpiryComplete",
                info.isExpiryComplete
              ],
              [
                "isCardNumberValid",
                info.isCardNumberValid
              ],
              [
                "isExpiryValid",
                info.isExpiryValid
              ]
            ]);
}

function buildPaymentMethodStatusEvent(paymentMethod, paymentMethodType, isSavedPaymentMethodOpt, isOneClickWalletOpt) {
  var isSavedPaymentMethod = isSavedPaymentMethodOpt !== undefined ? isSavedPaymentMethodOpt : false;
  var isOneClickWallet = isOneClickWalletOpt !== undefined ? isOneClickWalletOpt : false;
  return {
          paymentMethod: paymentMethod,
          paymentMethodType: paymentMethodType,
          isSavedPaymentMethod: isSavedPaymentMethod,
          isOneClickWallet: isOneClickWallet
        };
}

function paymentMethodStatusEventToJson(paymentMethod, paymentMethodType, isSavedPaymentMethodOpt, isOneClickWalletOpt) {
  var isSavedPaymentMethod = isSavedPaymentMethodOpt !== undefined ? isSavedPaymentMethodOpt : false;
  var isOneClickWallet = isOneClickWalletOpt !== undefined ? isOneClickWalletOpt : false;
  return Object.fromEntries([
              [
                "paymentMethod",
                paymentMethod
              ],
              [
                "isSavedPaymentMethod",
                isSavedPaymentMethod
              ],
              [
                "paymentMethodType",
                paymentMethodType
              ],
              [
                "isOneClickWallet",
                isOneClickWallet
              ]
            ]);
}

function buildFormStatusEvent(status) {
  return {
          status: PaymentEventTypes$OrcaPaymentPage.formStatusValueToString(status)
        };
}

function formStatusEventToJson(status) {
  return Object.fromEntries([[
                "status",
                PaymentEventTypes$OrcaPaymentPage.formStatusValueToString(status)
              ]]);
}

function buildPaymentMethodInfoAddress(country, state, postalCode) {
  return {
          country: country,
          state: state,
          postalCode: postalCode
        };
}

function paymentMethodInfoAddressToJson(country, state, postalCode) {
  return Object.fromEntries([
              [
                "country",
                country
              ],
              [
                "state",
                state
              ],
              [
                "postalCode",
                postalCode
              ]
            ]);
}

function computeFormStatus(isComplete, isEmpty) {
  if (isComplete) {
    return "Complete";
  } else if (isEmpty) {
    return "Empty";
  } else {
    return "Filling";
  }
}

function buildCvcStatusEvent(isCvcFocused, isCvcBlur, isCvcEmptyOpt, isCvcCompleteOpt) {
  var isCvcEmpty = isCvcEmptyOpt !== undefined ? isCvcEmptyOpt : true;
  var isCvcComplete = isCvcCompleteOpt !== undefined ? isCvcCompleteOpt : false;
  return {
          isCvcFocused: isCvcFocused,
          isCvcBlur: isCvcBlur,
          isCvcEmpty: isCvcEmpty,
          isCvcComplete: isCvcComplete
        };
}

function cvcStatusEventToJson($$event) {
  var baseFields = [
    [
      "isCvcEmpty",
      $$event.isCvcEmpty
    ],
    [
      "isCvcComplete",
      $$event.isCvcComplete
    ]
  ];
  var v = $$event.isCvcFocused;
  var withFocused = v !== undefined ? baseFields.concat([[
            "isCvcFocused",
            v
          ]]) : baseFields;
  var v$1 = $$event.isCvcBlur;
  var withBlur = v$1 !== undefined ? withFocused.concat([[
            "isCvcBlur",
            v$1
          ]]) : withFocused;
  return Object.fromEntries([[
                "cvcStatus",
                Object.fromEntries(withBlur)
              ]]);
}

function buildSurchargeEvent(surcharge, taxOnSurchargeOpt, displaySurchargeAmountOpt, displayTaxOnSurchargeAmountOpt, displayTotalSurchargeAmountOpt) {
  var taxOnSurcharge = taxOnSurchargeOpt !== undefined ? Caml_option.valFromOption(taxOnSurchargeOpt) : undefined;
  var displaySurchargeAmount = displaySurchargeAmountOpt !== undefined ? displaySurchargeAmountOpt : 0.0;
  var displayTaxOnSurchargeAmount = displayTaxOnSurchargeAmountOpt !== undefined ? displayTaxOnSurchargeAmountOpt : 0.0;
  var displayTotalSurchargeAmount = displayTotalSurchargeAmountOpt !== undefined ? displayTotalSurchargeAmountOpt : 0.0;
  return {
          surcharge: surcharge,
          taxOnSurcharge: taxOnSurcharge,
          displaySurchargeAmount: displaySurchargeAmount,
          displayTaxOnSurchargeAmount: displayTaxOnSurchargeAmount,
          displayTotalSurchargeAmount: displayTotalSurchargeAmount
        };
}

function surchargeEventToJson($$event) {
  var surchargeJson = Object.fromEntries([
        [
          "type",
          $$event.surcharge.type
        ],
        [
          "value",
          $$event.surcharge.value
        ]
      ]);
  return Object.fromEntries([
              [
                "surcharge",
                surchargeJson
              ],
              [
                "taxOnSurcharge",
                Core__Option.getOr(Core__Option.map($$event.taxOnSurcharge, (function (prim) {
                            return prim;
                          })), null)
              ],
              [
                "displaySurchargeAmount",
                $$event.displaySurchargeAmount
              ],
              [
                "displayTaxOnSurchargeAmount",
                $$event.displayTaxOnSurchargeAmount
              ],
              [
                "displayTotalSurchargeAmount",
                $$event.displayTotalSurchargeAmount
              ]
            ]);
}

export {
  shouldEmitEvent ,
  buildCardInfo ,
  buildCardInfoFromSavedCard ,
  cardInfoToJson ,
  buildPaymentMethodStatusEvent ,
  paymentMethodStatusEventToJson ,
  buildFormStatusEvent ,
  formStatusEventToJson ,
  buildPaymentMethodInfoAddress ,
  paymentMethodInfoAddressToJson ,
  computeFormStatus ,
  buildCvcStatusEvent ,
  cvcStatusEventToJson ,
  buildSurchargeEvent ,
  surchargeEventToJson ,
}
/* No side effect */
